import './App.css';
import Home from './components/Home';
import { CssBaseline } from '@mui/material'

function App() {
  return (
    <div className="App">
      <Home />
      <CssBaseline />

    </div>
  );
}

export default App;
